import './GoodsList.scss';
import { items } from '../../../mockData/Corn-data';
import Item from '../../../Item/itemCorn';
import React from 'react';

export default class GoodsList extends React.Component {
  constructor(props) {
    super(props);
    this.items = items;
  }

  render() {
    // якщо передали ids — фільтруємо; якщо ні — показуємо всі
    const ids = (this.props.ids || []).map(Number);
    const idsSet = new Set(ids);

    const visibleItems = idsSet.size
      ? this.items.filter((item) => idsSet.has(Number(item.id)))
      : this.items;
    return (
      <div className="goods">
        {visibleItems.map(item => (
          <Item
            key={item.id}
            isNew={item.isNew}
            title={item.title}
            InStock={item.InStock}
            link={item.link}
            inside={item.inside}
            priceFirst={item.priceFirst}
            priceSecond={item.priceSecond}
            priceThird={item.priceThird}
            priceFourth={item.priceFourth}
            skuFirst={item.skuFirst}
            skuSecond={item.skuSecond}
            skuThird={item.skuThird}
            skuFourth={item.skuFourth}
            imgFirst={item.imgFirst}
            imgSecond={item.imgSecond}
            imgThird={item.imgThird}
            imgFourth={item.imgFourth}
            unitFirst={item.unitFirst}
            unitSecond={item.unitSecond}
            unitThird={item.unitThird}
            unitFourth={item.unitFourth}
            producer={item.producer}
            imgUrl={item.imgUrl}
            table={item.table}
            imgLogo={item.imgLogo}
            logo={item.logo}
            description={item.description}
            recommendations={item.recommendations}
            id={item.id}
          />
        ))}
      </div>
    );
  }
}